// Modelo Grupo procesos preligrosos.
export default class DangerousProcess {
    id=""
    company=""
    companyJob=""
    type=true
    element=""
    value=""
    date=""
}



// WEBPACK FOOTER //
// ./src/model/DangerousProcess.js